import { LoadableLazy } from '@confluence/loadable';

export const ChangeStatusAndCancelApprovalModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ChangeStatusAndCancelApprovalModal" */ '../src/Modals/ChangeStatusAndCancelApprovalModal.tsx'
			)
		).ChangeStatusAndCancelApprovalModal,
});
